export const colors = {
  primary: {
    light: '#BEE7FF',
    main: '#0078C3',
    dark: '#004673',
  },
  secondary: {
    light: '#FF833D',
    main: '#FD5000',
    dark: '#CC4400',
  },
  purple: {
    ultraLight: '#E0C8DC',
    light: '#C191B9',
    main: '#832474',
    dark: '#530048',
  },
  white: '#FFFFFF',
  black: '#1F1D1C',
  yellow: '#FFC300',
  blue: {
    light: '#BEE7FF',
    sky: '#8CCDFA',
    main: '#0078C3',
    dark: '#004673',
    deep: '#002841',
  },
  grey00: '#4a4a4a',
  grey01: '#1F1D1C',
  hagerYellow: '#FFC300',
  hagerBatteryRegular: '#45D1DB',
  text: {
    contrastText: '#FFFFFF',
  },
  dirtyInput: '#fdffcc',
}

export const general = {
  spacingBase: 6,
  defaultBorderRadius: 0,
}

export const costSavingsChart = {
  threeSixtySavingsBatteryColor: '#FD5000',
  threeSixtySavingsWallboxColor: '#0078C3',
  consumptionPriceColor: '#737373',
  dynamicEmsNormalOperationColor: '#FFC300',
  dynamicEmsGridChargeColor: '#0078C3',
  dynamicEmsBlockDischargingColor: '#45D1DB',
}

export const systemChartColors = {
  BatPowerIn: '#45D1DB',
  BatPowerOut: '#27A6AF',
  NetIn: '#8CCDFA',
  NetOut: '#004673',
  ASOC: '#BEE7FF',
  DC_PowerL1: '#F57F17',
  DC_PowerL2: '#FFC238',
  DC_PowerL3: '#FFAA66',
  DC_PowerSolar: '#FFC300',
  DC_PowerTotal: '#70E58F',
  ForecastPower: '#FFC300',
  ThreeSixtySavings: '#8CCDFA',
  NetOutWithoutThreeSixtySavings: '#AFAFAF',
  Autarky: '#FFC300',
  WeatherBreakthrough: '#FFC300',
  ConsumptionTotal: '#CC4400',
  ConsumptionHouse: '#FD5000',
  DirectConsumption: '#BEE7FF',
  DirectConsumptionProduction: '#70E58F',
  Deration: '#D00A2E',
  SelfProduction: '#004673',
  Wallbox_energyAll: '#0078C3',
  Wallbox_energySolar: '#8CCDFA',
  Wallbox_energyNetOut: '#BEE7FF',
  Wallbox_energyDischarged: '#004673',
  Powermeter_NetIn: '#6633FF',
  Powermeter_NetOut: '#E15D38',
  Powermeter_production: '#6633FF',
  Powermeter_consumption: '#E15D38',
  Powermeter_NetIn_alien: '#6633FF',
  Powermeter_NetOut_alien: '#E15D38',
  Powermeter_NetIn_enera: '#D00A2E',
  Powermeter_NetIn_bypass: '#A1001D',
  Powermeter_NetIn_bypass_noCharge: '#A1001D',
  Custom_Sum: '#666666',
  GreenConsumption: '#27ADFD',
  Temperature: '#C43E00',
}

export const liveView = {
  liveViewItem: '#4a4a4a',
  liveViewBranch: '#1A8FC8',
  energyBubble: '#0078C3',
  energyBubbleActive: '#83bada',
  batteryIconFill: '#BCEEF2',
  flowIndicatorInColor: '#0078C3',
  flowIndicatorOutColor: '#4a4a4a',
}

export const wallboxWidget = {
  discharging: '#0078C3',
  dischargingStripes: '#004673',
  charging: '#45D1DB',
  chargingStripes: '#27A6AF',
}

export const batteryWidget = {
  progressBar: '#45D1DB',
  progressBarStripes: '#27A6AF',
}

export const eMobilityChartColors = {
  totalEnergyChargedBar: '#0DB2C7',
  totalGridChargedBarV1: '#00477E',
  totalGridChargedBar: '#00477E',
  totalGridChargedBarLightestShade: '#33c6ea',
  totalChargedBackground: '#BBDEE9',
  totalDischargedEnergyCardBackground: '#FAE6E6',
  totalDischargedEnergyBackgroundV1: '#CC6601',
  totalDischargedEnergyBackground: '#ADE2F2',
  solarChargedBarV1: '#F56400',
  solarChargedBar: '#F56400',
  solarChargedBarLightestShade: '#FFF485',
  solarChargedBackground: '#F4EFB9',
  solarStatCardIcon: '#E6A64C',
  chargeDurationCardBackground: '#C9EBC1',
  dynamicTariffChartAreaBackgroundColor: '#686868',
  dynamicTariffChartAreaStrokeColor: '#616161',
  dynamicTariffChartDotColor: '#4A4A4A',
  dynamicTariffChartReferenceLineColor: '#AFAFAF',
}
